import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import * as sha1 from 'js-sha1';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class SistemaProvaService {

  constructor(private httpClient: HttpClient) { }

  /**
   * Busca no sistema de provas, quais provas serão aplicadas para o candidato
   * @param cpf CPF do candidato
   * @returns
   */
  buscarProvas(cpf): Observable<any> {
    var code = sha1(cpf);
    return this.httpClient
      .get(`${environment.url_api_sistema_prova}/provaonline_buscar_prova_json.php?cod=${code}`);
  }

}
